import { Injectable } from '@angular/core';
import * as moment from 'moment/moment';
import { FlexPeriod } from './flex-period.service';

@Injectable({
	providedIn: 'root',
})
export class CsvDownloadService {
	download(csvContent: string, filename: string): void {
		const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
		const url = window.URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = filename;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
		window.URL.revokeObjectURL(url);
	}

	getFileName(name: string, date: moment.Moment, flexPeriod?: FlexPeriod): string {
		// Custom Name - March 3
		let day = date.format('MMMM D');
		const year = date.format('YYYY');
		let start = '';
		let end = '';

		if (flexPeriod) {
			// Flex Period Name - March 3, 4_00 PM-5_00 PM
			day = day + ', ';
			const schedule = flexPeriod.schedules.find((s) => s.days_of_week.includes(date.weekday()));
			if (schedule) {
				start = date.startOf('day').add(schedule.start_hour, 'hours').add(schedule.start_minute, 'minutes').format('h_mm A');
				end = date.startOf('day').add(schedule.end_hour, 'hours').add(schedule.end_minute, 'minutes').format(' - h_mm A');
			}
		}

		return `${name} - ${day}${start}${end} ${year}`;
	}
}
